// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d75258d9","453":"51378c8b","455":"d4d155c8","977":"859f0768"}[chunkId] + ".chunk.js";
};